import { render, staticRenderFns } from "./bo-return-popup.vue?vue&type=template&id=36d1043f"
import script from "./bo-return-popup.vue?vue&type=script&lang=js"
export * from "./bo-return-popup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports